import { createSlice } from '@reduxjs/toolkit';

const generalSlice = createSlice({
    name: 'general',
    initialState: {
        lastTransactionId: '',
    },
    reducers: {
        setLastTransactionId: (state, action) => {
            state.lastTransactionId = action.payload;

        },

    },
});

export const generalActions = generalSlice.actions;
export default generalSlice.reducer;